export const LocalStorageConstants = {
    SelectedBaseAssetSymbol: 'selected-base-asset-symbol',
    SelectedExpirationName: 'selected-expiration',
    SelectedOptionTypeName: 'selected-option-type',
    SelectedPortfolioName: 'selected-portfolio-name',
    SelectedStrikeName: 'selected-strike-name',
};